/*
* @Author: gujianghua
* @Date:   2021-04-22 17:50:01
* @Last Modified by:   gujianghua
* @Last Modified time: 2021-04-23 09:53:50
*/
import { service } from '@/utils/request'

export default {
	getCourse() {
		return service({
			url: '/cloud/course/v1/admin/red-package/getAdminList',
			method: 'get'
		})
	},
	createCourse(data) {
		return service({
			url: '/cloud/course/v1/admin/red-package/addRedPackageCourse',
			method: 'post',
			data
		})
	},
	updateCourse(data) {
		return service({
			url: '/cloud/course/v1/admin/red-package/updateRedPackageCourse',
			method: 'post',
			data
		})
	},
	deleteCourse(params) {
		return service({
			url: '/cloud/course/v1/admin/red-package/deleteCourseById',
			method: 'get',
			params
		})
	},
    getPop() {
		return service({
			url: '/cloud/activity/v1/package-ad-settings/get',
			method: 'get'
		})
    },
    updatePop(data) {
        return service({
			url: '/cloud/activity/v1/package-ad-settings/update',
			method: 'post',
            data
		})
    },
	getSetting(params) {
		return service({
			url: '/cloud/activity/v1/package-settings/getAllSettings',
			method: 'get',
			params
		})
	},
	updateSetting(data) {
		return service({
			url: '/cloud/activity/v1/package-settings/updateSetting',
			method: 'post',
			data
		})
	},
}


// WEBPACK FOOTER //
// ./src/api/operateManage/redpacket.js